import React, { useMemo } from 'react';
import { FaRedo, FaUserFriends, FaUserAlt } from 'react-icons/fa';
import './AdminCampana6.css';

function AdminCampana6({
  selectedOption, handleChange, campaigns, promiseInProgress, IDcampana,
  visible, refrescar, dinamicTableExtra, hora, minuto, segundo,
  dinamicTable, total, finalizada, askForFinish, clase, askForReset
}) {

  // ── Agrupamos dinamicTable por "descripcion" (mismo texto = mismo artículo) ──
  // row.Nombre viene con formato "SI - Artículo No. X" o "NO - Artículo No. X",
  // extraemos el prefijo para clasificar SI / NO.
  const articulos = useMemo(() => {
    const grupos = {};
    dinamicTable.forEach((row) => {
      const key = row.descripcion;
      if (!grupos[key]) {
        grupos[key] = { descripcion: key, si: null, no: null };
      }
      const nombreUpper = row.Nombre.trim().toUpperCase();
      if (nombreUpper.startsWith('SI')) {
        grupos[key].si = row;
      } else if (nombreUpper.startsWith('NO')) {
        grupos[key].no = row;
      }
    });
    return Object.values(grupos);
  }, [dinamicTable]);

  const calcularPorcentaje = (conteoArticulo, art) => {
    if (!art) return 0;
    const votosSi = art.si ? art.si.conteo : 0;
    const votosNo = art.no ? art.no.conteo : 0;
    const totalArticulo = votosSi + votosNo;
    if (totalArticulo === 0) return 0;
    return Number(((conteoArticulo / totalArticulo) * 100).toFixed(1));
  };

  return (
    <div className="dashboard admin11-dashboard">
      <center>
        <div className="admin11-layout">
          {/* ── Header y Selector de campaña ── */}
          <div className="admin11-header-container">
            <div className='admin11-select-row'>
              <select className="admin11-select" value={selectedOption} onChange={(e) => handleChange(e)} defaultValue="0" disabled={promiseInProgress ? "disabled" : ""}>
                {campaigns.map((obj) => (
                  <option key={obj.IDCampana} value={obj.IDCampana}>
                    {obj.Nombre}
                  </option>
                ))}
                <option defaultValue value="0" disabled="disabled">
                  {promiseInProgress ? "Cargando opciones..." : "Seleccione una opción"}
                </option>
              </select>
              {IDcampana !== 0 && visible === true && (
                <button className="admin11-refresh-btn" onClick={refrescar} disabled={promiseInProgress ? "disabled" : ""} title="Actualizar datos">
                  <FaRedo />
                </button>
              )}
            </div>
          </div>

          {/* ── Contadores + Cronómetro ── */}
          {dinamicTableExtra.map(function (extra, index) {
            return (
              <div className="admin11-counters-row" key={index}>
                <div className="admin11-counter-card inscritos">
                  <span className="admin11-counter-label">Inscritos</span>
                  <div className="admin11-counter-value">
                    <FaUserFriends /> <span>{extra.votantes}</span>
                  </div>
                </div>
                <div className="admin11-counter-card votantes">
                  <span className="admin11-counter-label">Votantes</span>
                  <div className="admin11-counter-value">
                    <FaUserAlt /> <span>{extra.votos}</span>
                  </div>
                </div>
                <div className="admin11-counter-card crono">
                  <span className="admin11-counter-label">Tiempo Transcurrido</span>
                  <div className="admin11-counter-value">
                    {hora.toString().padStart(2, '0')}:{minuto.toString().padStart(2, '0')}:{segundo.toString().padStart(2, '0')}
                  </div>
                </div>
              </div>
            );
          })}

          {/* ── Tabla SI / NO agrupada por artículo ── */}
          {articulos.length > 0 && (
            <div className="admin11-table-wrap">
              <table className="admin11-table admin11-table-sino">
                <thead>
                  <tr>
                    <th>Artículo (Listado completo)</th>
                    <th className="text-center">Votación SI (%)</th>
                    <th className="text-center">Votación NO (%)</th>
                  </tr>
                </thead>
                <tbody>
                  {articulos.map((art) => {
                    const pctSi = calcularPorcentaje(art.si ? art.si.conteo : 0, art);
                    const pctNo = calcularPorcentaje(art.no ? art.no.conteo : 0, art);
                    return (
                      <tr key={art.descripcion} className="admin11-table-row-anim">
                        <td className="admin11-name-col">
                          <div
                            className="admin11-name-inner"
                            dangerouslySetInnerHTML={{ __html: art.descripcion }}
                          />
                        </td>

                        {/* ── Barra SI ── */}
                        <td className="admin11-bar-col">
                          <div className="admin11-bar-row">
                            <div className="admin11-progress-track admin11-progress-track-si">
                              <div
                                className="admin11-progress-fill admin11-progress-fill-si"
                                style={{ width: `${pctSi}%` }}
                              >
                                {art.si && (
                                  <span className="admin11-votos-inline">{pctSi}%</span>
                                )}
                              </div>
                            </div>
                            <span className="admin11-pct-label admin11-pct-si">{art.si ? art.si.conteo : 0} Votos</span>
                          </div>
                        </td>

                        {/* ── Barra NO ── */}
                        <td className="admin11-bar-col">
                          <div className="admin11-bar-row">
                            <div className="admin11-progress-track admin11-progress-track-no">
                              <div
                                className="admin11-progress-fill admin11-progress-fill-no"
                                style={{ width: `${pctNo}%` }}
                              >
                                {art.no && (
                                  <span className="admin11-votos-inline">{pctNo}%</span>
                                )}
                              </div>

                            </div>
                            <span className="admin11-pct-label admin11-pct-no">{art.no ? art.no.conteo : 0} Votos</span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* ── Botones Finalizar / Reiniciar ── */}
          <div className="admin11-actions">
            {finalizada}
            <button className="admin11-action-btn finalize"
              disabled={finalizada ? "disabled" : ""}
              onClick={askForFinish}>
              {promiseInProgress ? "Finalizando..." : "Finalizar Votación"}
              {promiseInProgress}
            </button>
            {clase === 3 && finalizada ? (
              <button className="admin11-action-btn restart"
                onClick={askForReset}>
                {promiseInProgress ? "Reiniciando..." : "Reiniciar Votación"}
                {promiseInProgress}
              </button>
            ) : null}
          </div>
        </div>
      </center>
    </div>
  );
}

export default AdminCampana6;
